import React, { useState } from 'react';

/**
 * LoadingImage — an <img> wrapped in a frame that shows a skeleton shimmer
 * until the image loads, then fades the image in. On error it keeps the calm
 * skeleton background rather than showing a broken-image icon, so content
 * never pops in abruptly or breaks the layout.
 */
const LoadingImage = ({ src, alt = '', className = '', imgClassName = '', style }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <div className={`img-frame ${className}`} style={style}>
      {!loaded && !failed && <div className="img-skeleton" aria-hidden="true" />}
      {!failed && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className={`img-loadable ${imgClassName} ${loaded ? 'is-loaded' : ''}`}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
};

export default LoadingImage;
